module.exports = __webpack_public_path__ + "static/media/anne-hathaway.093b3360.jpg";